export default {
	state: {
		menu: {}
	},

	mutations: {
		setMenu(store, value) {
			store.menu = value
		}
	},

	actions: {
		async loadMenu({ commit, dispatch }) {
			await commit('setMenu', await dispatch('apiGuestRequest', {method: 'GET', endpoint: '/menu/?mapped=true'}))
		}
	},

	getters: {
		menuCategoriesMap(store) {
			return store.menu.categories || {}
		},
		menuCategories(_, getters) {
			return Object.values(getters.menuCategoriesMap).sort((a, b) => a.sort_order - b.sort_order)
		},
		menuItemsMap(store) {
			return store.menu.items || {}
		},
		menuItems(_, getters) {
			return Object.values(getters.menuItemsMap).sort((a, b) => a.sort_order - b.sort_order)
		},
		menuMergedItems(_, getters) {
			let merged = Object.values(getters.menuCategoriesMap).reduce((prev, cur) => {
				prev[cur.id] = {
					...cur,
					items: []
				}
				return prev
			}, {})
			

			getters.menuItems.forEach(el => {
				merged[el.category_ref].items.push({...el})
			})

			let a = Object.values(merged).sort((a,b) => a.sort_order - b.sort_order)//.map(el => ({...el, items: el.items.sort((a,b) => a.sort_order - b.sort_order)}))

			return a
		}
	}
}